import { Link } from "wouter";

interface BrandProps {
  /** The footer shows a larger mark than the navbar. */
  size?: "sm" | "lg";
}

/**
 * Logo link from the redesign mockup: the HBT mark filled with an animated
 * gradient (`.logo` in design.css) next to the stacked "HBT / INTEGRISYS"
 * wordmark.
 */
export function Brand({ size = "sm" }: BrandProps) {
  if (size === "lg") {
    return (
      <Link className="brand" href="/" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <span className="logo-wrap" aria-hidden="true"><span className="logo" style={{ width: "44px", height: "50px" }}></span></span>
        <svg role="img" aria-label="HBT Integrisys" width="72" height="44" viewBox="0 0 72 44" style={{ display: "block", overflow: "visible" }}><text x="36" y="27" textAnchor="middle" fill="#FFFFFF" style={{ fontFamily: "Sora, sans-serif", fontWeight: "700", fontSize: "34px" }}>HBT</text><text x="1.75" y="42" textLength="68.5" lengthAdjust="spacing" fill="#A9B2C5" style={{ fontFamily: "Sora, sans-serif", fontWeight: "500", fontSize: "11px" }}>INTEGRISYS</text></svg>
      </Link>
    );
  }
  return (
    <Link className="brand" href="/" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
      <span className="logo-wrap" aria-hidden="true"><span className="logo" style={{ width: "36px", height: "41px" }}></span></span>
      <svg role="img" aria-label="HBT Integrisys" width="60" height="36" viewBox="0 0 60 36" style={{ display: "block", overflow: "visible" }}><text x="30" y="22" textAnchor="middle" fill="#FFFFFF" style={{ fontFamily: "Sora, sans-serif", fontWeight: "700", fontSize: "28px" }}>HBT</text><text x="1.5" y="34" textLength="57" lengthAdjust="spacing" fill="#A9B2C5" style={{ fontFamily: "Sora, sans-serif", fontWeight: "500", fontSize: "9px" }}>INTEGRISYS</text></svg>
    </Link>
  );
}
